// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"fa7f71b7","513":"6d1c28a1","703":"411798f7","787":"49c7bb89"}[chunkId] + ".chunk.js";
};